const benefits = [
  {
    icon: 'ri-recycle-line',
    title: 'Decarbonise the Hard-to-Abate Sectors',
    description: "Green hydrogen is the leading solution for decarbonising industries that can't run on direct electricity — including steel, cement, ammonia, heavy transport, and shipping. It stores renewable energy in a chemical form that can be used wherever and whenever needed.",
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    icon: 'ri-ship-2-line',
    title: "Australia's $50B Export Advantage",
    description: 'Australia has the renewable energy resources, land, infrastructure, and trusted trading relationships to become the dominant global green hydrogen exporter. Japan, South Korea, Germany, and Singapore are all actively seeking long-term hydrogen supply from Australia.',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-battery-fill',
    title: 'Long-Duration Energy Storage',
    description: "Green hydrogen solves the storage problem at scale. Excess renewable electricity is converted to hydrogen via electrolysis, stored indefinitely, and reconverted to electricity or used industrially. It's the only clean energy storage technology capable of seasonal-scale storage.",
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    icon: 'ri-car-line',
    title: 'Zero-Emission Transport Fuel',
    description: "Hydrogen fuel cell vehicles (FCEVs) are deployed in buses, trucks, trains, and ships where battery electric is impractical due to weight, range, or refuelling time constraints. Australia's heavy vehicle and port logistics sectors are prime candidates for hydrogen fuel adoption.",
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Green Ammonia for Agriculture',
    description: "Green hydrogen is used to produce green ammonia — a carbon-free fertiliser that can replace conventional ammonia made from fossil gas. Australia's agricultural sector and Asia-Pacific food production markets represent a major near-term opportunity for green ammonia exports.",
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-government-line',
    title: 'Strong Government & Policy Support',
    description: "Australia's National Hydrogen Strategy, the $2B Hydrogen Headstart production incentive, ARENA grants, CEFC low-cost finance, and state hydrogen strategies in SA, WA, VIC, QLD, and NSW create a comprehensive support framework for hydrogen project development.",
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
];

export default function HydrogenBenefits() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-50 border border-accent-200/60 mb-5">
            <i className="ri-test-tube-line text-accent-700 text-sm"></i>
            <span className="text-xs font-semibold text-accent-800 tracking-wide uppercase whitespace-nowrap">Why Hydrogen</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4">
            Why Green Hydrogen is Central<br className="hidden md:block" /> to Australia&rsquo;s Clean Energy Future
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Hydrogen is the missing piece in the clean energy puzzle — enabling decarbonisation of industries, transport, and export economies that electricity alone cannot reach.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {benefits.map((benefit) => (
            <article
              key={benefit.title}
              className="bg-background-100/70 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-accent-200 hover:bg-background-50 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 rounded-xl ${benefit.bg} flex items-center justify-center mb-5 group-hover:scale-105 transition-transform duration-300`}>
                <i className={`${benefit.icon} text-xl ${benefit.color}`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{benefit.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}